import type { SiteName } from '@/scopes/common/domain/types'

const DISCOUNTS_MORE_INFO_URLS: Partial<Record<SiteName, string>> = {
  sunwebnl: '/mijn-sunweb/voucher-korting-voorwaarden',
  sunwebbenl: '/nl/mijn-sunweb/voucher-korting-voorwaarden',
  sunwebbefr: '/fr/mon-sunweb/discount-terms-and-conditions',
  sunwebde: '/mein-sunweb/discount-terms-and-conditions',
  sunwebdk: '/mit-sunweb/discount-terms-and-conditions',
  sunwebfr: '/mon-sunweb/discount-terms-and-conditions',
  sunwebse: '/mitt-sunweb/discount-terms-and-conditions',
  sunwebuk: '/my/discount-terms-and-conditions',
}

export function getDiscountsMoreInfoUrl(siteName: SiteName): string | undefined {
  return DISCOUNTS_MORE_INFO_URLS[siteName]
}
